export function sendTimingLog(params: {
    url: string;
    method: string;
    duration: number;
    status: number;
    code: number;
    error?: boolean;
}) {
    if (!window?.mtstat?.track) return;
    const { url, method, duration, status, code, error } = params;

    // 请求耗时埋点
    window.mtstat.track('http_request_timing', {
        duraction: (duration / 1000).toFixed(2),
        error: error ? 1 : 0,
        status,
        method,
        url,
        code,
    });
}
